module.exports = __webpack_public_path__ + "a1415f8bb87eaabf50b70907576c7be8.svg";